import { gql, useQuery } from "@apollo/client";
import { ErrorComponent } from "@src/components";
import Summary from "@src/components/summary/Summary";
import { type GQLUserSummaryDashboardAdminQuery, type GQLUserSummaryDashboardAdminQueryVariables } from "@src/graphql.generated";
import Calendar from "@src/icons/Calendar";
import UserWithActiveSim from "@src/icons/UserWithActiveSim";
import UserWithLicence from "@src/icons/UserWithLicence";
import UserWithoutLicence from "@src/icons/UserWithoutLicence";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

const userSummaryDashboardAdminQuery = gql`
    query UserSummaryDashboardAdmin {
        userSummaryDashboardAdmin {
            usersWithLicencesCount
            usersWithoutLicencesCount
            usersWithActivatedSimCount
            licenceWillExpireCount
        }
    }
`;

const UsersSummary: FC<PropsWithChildren> = () => {
    const { data, error } = useQuery<GQLUserSummaryDashboardAdminQuery, GQLUserSummaryDashboardAdminQueryVariables>(userSummaryDashboardAdminQuery);
    const intl = useIntl();

    const summaryItems = [
        {
            count: data?.userSummaryDashboardAdmin.usersWithActivatedSimCount,
            text: <FormattedMessage id="reviermanager.page.dashboard.summary.userWithSim" defaultMessage="Kunden mit aktiver SIM-Karte" />,
            icon: <UserWithActiveSim fontSize="large" color="primary" />,
        },
        {
            count: data?.userSummaryDashboardAdmin.usersWithLicencesCount,
            text: <FormattedMessage id="reviermanager.page.dashboard.summary.usersWithLicence" defaultMessage="Kunden mit Lizenz" />,
            icon: <UserWithLicence fontSize="large" color="primary" />,
        },
        {
            count: data?.userSummaryDashboardAdmin.usersWithoutLicencesCount,
            text: <FormattedMessage id="reviermanager.page.dashboard.summary.usersWithoutLicence" defaultMessage="Kunden ohne Lizenz" />,
            icon: <UserWithoutLicence fontSize="large" color="primary" />,
        },

        {
            count: data?.userSummaryDashboardAdmin.licenceWillExpireCount,
            text: (
                <FormattedMessage
                    id="reviermanager.page.dashboard.summary.camerasWithExpiringLicence"
                    defaultMessage="auslaufende Lizenzen nächste 30 Tage"
                />
            ),
            icon: <Calendar fontSize="large" color="primary" />,
        },
    ];

    if (error) {
        return <ErrorComponent />;
    }

    return (
        <Summary
            items={summaryItems}
            title={intl.formatMessage({ id: "reviermanager.page.dashboard.summary.users", defaultMessage: "Kunden" })}
            variant="dashboard"
        />
    );
};

export default UsersSummary;
